import React from 'react';
import { Navbar,Container,Form,Button,FormControl,Spinner,Nav } from 'react-bootstrap';
const NavbarWithSearch=(props)=>{
    return(
        <Navbar bg="primary" expand="lg">
            <Container fluid>
                <Navbar.Brand href="#"><strong>LC Generator</strong></Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                <Form className="d-flex" onSubmit={e => { e.preventDefault(); }}>
                    <FormControl
                        type="search"
                        placeholder="Enter SAP ID"
                        className="me-2"
                        aria-label="Search"
                        onInput={(e) => {props.setInputSAP(e.target.value)}}
                    />
                    <Button onClick={props.submitSAP} variant="dark" style={{margin:'0 5px'}}>Search</Button>
                    
                </Form>
               {props.loading? <Spinner animation="border" />:''} 
                
                </Navbar.Collapse>
                <Nav className="mr-auto">
                    <Nav.Link href="/home"><strong>Home</strong></Nav.Link>
                </Nav>
                <Nav className="mr-auto">
                    <Nav.Link href="/previous-lc"><strong>Previous LC</strong></Nav.Link>
                </Nav>
            </Container>
        </Navbar>
    );
}

export default NavbarWithSearch
